import {useCallback, useEffect, useState} from "react";
import {GeofenceEntity, geofenceTriggerType, SiteEntity} from "@ots-frontend/ots-data";
import {GeofenceMarker} from "../marker/GeofenceMarker/GeofenceMarker";
import {Marker} from "../marker/Marker/Marker";
import {Map, useMapLoader} from "../Map/Map";

export type SiteMapProps = {
  site: SiteEntity;
  geofences?: GeofenceEntity[];
  height: number | string;
  width: number | string;
  zoom?: number;
  apiKey: string;
}

const DEFAULT_MAP_OPTIONS: google.maps.MapOptions = {
  mapTypeId: "satellite",
  disableDefaultUI: true,
  mapTypeControl: false,
  streetViewControl: false
};

export const SiteMap = (props: SiteMapProps) => {
  const {apiKey, site, geofences = [], height, width, zoom = 15} = props;

  const {isLoaded: isMapLoaded} = useMapLoader({
    googleMapsApiKey: apiKey
  });

  const [_map, setMap] = useState<google.maps.Map | null>(null);

  const [center, setCenter] = useState<google.maps.LatLngLiteral | undefined>(
    site.latLng ? {lat: site.latLng.latCoord, lng: site.latLng.longCoord} : undefined
  );
  const [primary, setPrimary] = useState<GeofenceEntity | undefined>(undefined);

  const onMapLoad = useCallback((map: google.maps.Map) => {
    setMap(map);
  }, []);

  const onMapUnmount = useCallback((map: google.maps.Map) => {
    setMap(null);
  }, []);

  useEffect(() => {
    const primary = geofences.find(
      (g) => g.triggerType === geofenceTriggerType.primary
    );

    setPrimary(primary);

    if (primary) {
      setCenter({lat: primary.latLng.latCoord, lng: primary.latLng.longCoord});
    } else {
      setCenter(site.latLng ? {lat: site.latLng.latCoord, lng: site.latLng.longCoord} : undefined);
    }
  }, [site, geofences]);

  if (typeof center === "undefined") {
    return <div/>;
  }

  if (typeof center === "undefined" || !isMapLoaded) {
    return <div/>;
  }

  return (
    <Map
      onLoad={onMapLoad}
      onUnmount={onMapUnmount}
      zoom={zoom}
      center={center}
      mapContainerStyle={{width: width, height: height}}
      options={DEFAULT_MAP_OPTIONS}
    >
      {typeof primary === "undefined" && <Marker position={center}/>}
      {geofences.map((g) => {
        return (
          <GeofenceMarker
            key={g.id}
            entity={g}
            showGeofence={true}
          />
        );
      })}
    </Map>
  );
};
